import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Button, ButtonGroup, Col, Container, FloatingLabel, Form, Image, Row, Spinner, Tab, Tabs, ToggleButton } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import Dialog from './Dialog';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService';
import SexualExpressionDisplayFlag from '../domain/PG12DisplayFlag';
import Language from '../domain/Language';
import * as Icon from 'react-bootstrap-icons';

const MosaicEditPopup = (props) => {
    async function getUserInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getImageData(type,groupId,detailId,detailNo){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+type+"/data/"+groupId+"/"+detailId+"/"+detailNo).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function saveImageData(type,groupId,detailId,detailNo,image){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+type+"/data/"+groupId+"/"+detailId+"/"+detailNo,{image:image}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function setCanvas(image){
        let data = image
        let canvas = document.createElement("canvas")
        canvas.id = "canvas"
        let ctx = canvas.getContext("2d")

        let img = document.createElement("img")
        img.src = data
        img.onload = () => {
            let w = 0
            let h = 0
            if(img.naturalWidth > img.naturalHeight){
                w = window.innerWidth
                h = img.naturalHeight * (window.innerWidth / img.naturalWidth)
            } else {
                w = img.naturalWidth * ((window.innerHeight - 110) / img.naturalHeight)
                h = window.innerHeight - 110
            }
            w = img.naturalWidth
            h = img.naturalHeight
            canvas.width = w
            canvas.height = h
            //canvas.style.border = "5px solid #FFFFFF"
            canvas.style.zIndex = "5"
            canvas.style.margin = "0"
            canvas.style.padding = "0"
            canvas.onmouseup = (e) => canvasMouseUp(e)
            canvas.onmousedown = (e) => canvasMouseDown(e)
            canvas.onmousemove = (e) => canvasMouseMove(e)
            console.log(1)
            ctx.drawImage(img,0,0,img.naturalWidth,img.naturalHeight,0,0,w,h)
            document.getElementById("canvas-area").textContent = ""
            document.getElementById("canvas-area").append(canvas)

            setOriginalImage(img)
            setMosaicImage()
            //setMaskImage()
        }
        return true
    }
    function setMosaicImage(){
        let originalImage = getOriginalImage()
        let ctx = originalImage.getContext("2d")

        let mosaicCanvas = document.getElementById("mosaic-image")
        mosaicCanvas.width = originalImage.width
        mosaicCanvas.height = originalImage.height
        let mosaicCtx = mosaicCanvas.getContext("2d")

        let imgData = ctx.getImageData(0, 0, originalImage.width, originalImage.height)
        if (imgData !== "") {
            if(getMosaicStyle() === "dot"){
                let mosaicSize = parseInt(getMosaicStrength(), 10)
                for (let y = 0; y < imgData.height; y+=mosaicSize) {
                    for (let x = 0; x < imgData.width; x+=mosaicSize) {
                        let cR = imgData.data[(y * imgData.width + x) * 4]
                        let cG = imgData.data[(y * imgData.width + x) * 4 + 1]
                        let cB = imgData.data[(y * imgData.width + x) * 4 + 2]
                        mosaicCtx.fillStyle = "rgb("+cR+","+cG+","+cB+")"
                        mosaicCtx.fillRect(x,y,x + mosaicSize,y + mosaicSize)
                    }
                }
            } else if(getMosaicStyle() === "blur"){
                let tempImg = document.createElement("canvas")
                tempImg.width = originalImage.width
                tempImg.height = originalImage.height
                let imageData = ctx.getImageData(0,0,originalImage.width,originalImage.height)
                let tempCtx = tempImg.getContext("2d")
                tempCtx.putImageData(imageData,0,0)

                mosaicCtx.filter = "blur(" + getMosaicStrength() + "px)"
                mosaicCtx.drawImage(tempImg,0,0)
            }
        }
    }
    function setMaskImage(){
        let originalImage = getOriginalImage()
        let ctx = originalImage.getContext("2d")
        let mosaicCanvas = document.getElementById("mosaic-image")
        mosaicCanvas.width = originalImage.width
        mosaicCanvas.height = originalImage.height
        let mosaicCtx = mosaicCanvas.getContext("2d")
        mosaicCtx.clearRect(0, 0, originalImage.width, originalImage.height)

    }
    function mosaicCanvas(){
        setImageEditFlag(1)
        let drawCanvas = document.getElementById("canvas")
        let ctx = drawCanvas.getContext("2d")

        let mosaicCanvas = document.getElementById("mosaic-image")
        let mosaicCtx = mosaicCanvas.getContext("2d")

        let mosaicImgData = mosaicCtx.getImageData(0, 0, drawCanvas.width, drawCanvas.height)
        ctx.putImageData(mosaicImgData,0, 0)
    }
    function getMosaicImage() {
        return document.getElementById("mosaic-image")
    }
    let mousePress = false
    function canvasMouseUp(e) {
        mousePress = false
    }
    function canvasMouseDown(e) {
        mousePress = true
        canvasMouseMove(e)
    }
    function setDrawFlag(flag){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.selectdrawflag = flag
    }
    function getDrawFlag(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.selectdrawflag
    }
    function setOriginalImage(img){
        let original = document.getElementById("original-image")
        original.width = img.naturalWidth
        original.height = img.naturalHeight
        let originalCtx = original.getContext("2d")
        // console.log(img.naturalWidth,img.naturalHeight)
        originalCtx.drawImage(img,0,0,img.naturalWidth,img.naturalHeight,0,0,img.naturalWidth,img.naturalHeight)
    }
    function getOriginalImage(){
        return document.getElementById("original-image")
    }
    function setMosaicSize(size){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicsize = size
    }
    function getMosaicSize(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicsize
    }
    function setMosaicStrength(strength){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicstrength = strength
    }
    function getMosaicStrength(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicstrength
    }
    function setMosaicStyle(style){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicstyle = style
    }
    function getMosaicStyle(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicstyle
    }
    function canvasMouseMove(e) {
        if(!mousePress) return
        let drawFlag = getDrawFlag()
        let mosaicSize = getMosaicSize()
        // 描画モード
        if(drawFlag === "1"){
            setImageEditFlag(1)
            let client = e.currentTarget.getBoundingClientRect()
            // console.log(e.pageY,client.top,client.y,window.scrollY)
            let x = e.pageX - client.x - window.scrollX - mosaicSize / 2
            let y = e.pageY - client.y - window.scrollY - mosaicSize / 2

            let mosaicImageCtx = getMosaicImage().getContext("2d")
            let ctx = e.currentTarget.getContext("2d")

            let imageData = mosaicImageCtx.getImageData(x,y,mosaicSize,mosaicSize)
            ctx.putImageData(imageData,x,y)
        }
        // 消しゴムモード
        if(drawFlag === "2"){
            setImageEditFlag(1)
            let client = e.currentTarget.getBoundingClientRect()
            let x = e.pageX - client.x - mosaicSize / 2
            let y = e.pageY - client.y - mosaicSize / 1

            let ctx = e.currentTarget.getContext("2d")
            ctx.drawImage(getOriginalImage(),x,y,mosaicSize,mosaicSize,x,y,mosaicSize,mosaicSize)
        }
    }
    function resetCanvas() {
        setImageEditFlag(0)
        let canvas = document.getElementById("canvas")
        let ctx = canvas.getContext("2d")
        let img = document.createElement("img")
        img.src = imageDataOriginal
        img.onload = () => {
            ctx.drawImage(img,0,0)
        }
    }
    // 変更内容を保存
    function saveEdit() {
        setSaving(true)
        saveImageData(props.type,groupId,detailId,props.detailNo || 0,document.getElementById("canvas").toDataURL("image/png")).then(r => {
            if(r.result){
                dialog(t("common.confirm"),"画像を更新しました。")
            } else {
                dialog(t("common.error"),r.errors)
            }
            setSaving(false)
        })
    }
    // 保存せず閉じる
    function closeEdit() {
        props.switch(false)
    }
    function setImageEditFlag(flag){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.imageeditflag = flag
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    // ナビゲート
    const navigate = useNavigate();

    const [imagePage,setImagePage] = useState(1)
    const [groupId,setGroupId] = useState(props.groupId)
    const [detailId,setDetailId] = useState(props.detailId)
    const [imageDataOriginal,setImageDataOriginal] = useState("")
    const [editLabel,setEditLabel] = useState("mosaic")
    const [saving,setSaving] = useState(false)

    // キャンバスのリサイズ
    const [canvasAreaHeight,setCanvasAreaHeight] = useState(window.innerHeight - 100)

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [button, setButton] = useState()
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // フラグ：AI生成作品を表示する
    const [sexualExpressionValue, setSexualExpressionValue] = useState('2') // 性的表現(軽微)
    const [r18Value, setR18Value] = useState('2')
    const [r18GValue, setR18GValue] = useState('2')
    const [userInfo, setUserInfo] = useState([])
    const [userSetting, setUserSetting] = useState([])
    const [ageLimit, setAgeLimit] = useState(1)
    const [language, setLanguage] = useState(1)

    // 初期処理
    useEffect(() => {
        // タイトル設定
        //document.querySelector("title").textContent = t("category.setting") + " - アワートAI"
        getUserInfo().then(r=>{
            setUserInfo(r)
        })
        getUserSetting().then(r=>{
            setUserSetting(r)
            setSexualExpressionValue(String(r.data.sexual_expression_display_flag))
            setR18Value(String(r.data.r18_display_flag))
            setR18GValue(String(r.data.r18g_display_flag))
            setLanguage(String(r.data.language))
        })
        if(groupId !== undefined && detailId !== undefined){
            // 既存のデータを編集するモード
            getImageData(props.type,groupId,detailId,props.detailNo || 0).then(r => {
                if(r.result){
                    let base64 = r.data.image
                    setImageDataOriginal(base64)
                    setCanvas(base64)
                } else {
                    dialog(t("common.error"),r.errors)
                }
            })
        }
    },[imagePage])

    // ログイン情報が取得出来たらプロフィール画像に設定
    useEffect(() => {
        if(loginInfo.result === false){
            navigate("/")
        }
    },[loginInfo])

    document.onkeydown = (e) => {
        if(e.key === "Escape"){
            props.switch(false)
        }
    }
    return (
        <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",backgroundColor:"#000000",zIndex:6}}>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <div id="mosaic-edit-popup" style={{position:"fixed",top:"1%",left:"1%",width:"98%",height:"98%",zIndex:7,overflow:"auto",backgroundColor:"#FFFFFF",borderRadius:"20px"}}>
        <Button variant='secondary' className='m-3' style={{position:"fixed",zIndex:1}} onClick={() => props.switch(false)}>{t("common.close")}</Button>
        <Container className='d-flex flex-row justify-content-center flex-wrap' style={{marginTop:"60px"}}>
            <div style={{display:groupId !== -1 ? "block" : "none",position:"fixed",top:0,width:"100%",height:"100%",background:"#000000",zIndex:4,opacity:"0.9"}}>
            </div>
            <div id="paint-tools" style={{display:groupId !== -1 ? "block" : "none",position:"fixed",top:0,color:"#FFFFFF",margin:"0 auto",zIndex:4,width:"100%"}} className="text-center">
                <div style={{width:"100%"}} className="d-flex justify-content-center">
                    <p style={{display:"block"}}>モザイクのスタイル：</p>
                    <Form.Select id="mosaic-size" className="mb-1" style={{display:"block",width:"100px"}}
                        onChange={(e) => {
                            setMosaicStyle(e.currentTarget.value)
                            setMosaicImage()
                        }}>
                        <option value="dot">ドット</option>
                        <option value="blur">ぼかし</option>
                    </Form.Select>
                    <p style={{display:"block"}}>モザイクの大きさ：</p>
                    <Form.Select id="mosaic-size" className="mb-1" style={{display:"block",width:"100px"}}
                        onChange={(e) => {
                            setMosaicSize(e.currentTarget.value)
                        }} defaultValue={30}>
                        {[...Array(30)].map((v,i) => {
                            return <option value={(i+1)*2} key={i}>{(i+1)*2}px</option>
                        })}
                    </Form.Select>
                    <p style={{display:"block"}}>モザイク強度：</p>
                    <Form.Control type="number" id="mosaic-strength" min={1} className="mb-1" style={{display:"block",width:"100px"}}
                        onChange={(e) => {
                            setMosaicStrength(e.currentTarget.value)
                            setMosaicImage()
                        }} defaultValue={20}>
                    </Form.Control>
                </div>
                <Button variant={editLabel === "mosaic" ? 'light' : "primary"} onClick={() => {
                    setDrawFlag(1)
                    setEditLabel("mosaic")
                }}><Icon.BrushFill /></Button>
                <Button variant={editLabel === "eraser" ? 'light' : "primary"} style={{marginLeft:"3px"}} onClick={() => {
                    setDrawFlag(2)
                    setEditLabel("eraser")
                }}><Icon.EraserFill /></Button>
                <Button variant='primary' style={{marginLeft:"3px"}} onClick={() => {
                    mosaicCanvas()
                }}>全体をモザイク</Button>
                <Button variant='success' style={{marginLeft:"3px"}} onClick={() => {
                    saveEdit()
                }}>OK</Button>
                <Button variant='danger' style={{marginLeft:"3px"}} onClick={() => {
                    resetCanvas()
                }}>Reset</Button>
                <Button variant='danger' style={{marginLeft:"3px"}} onClick={() => {
                    closeEdit()
                }}>Close</Button>
                <br />
                <canvas id="tempCanvas" style={{display:"none"}} />
                {imageDataOriginal === "" ? (
                    <div style={{fontWeight:"bold"}} className="mt-3">
                        読み込み中
                        <Spinner animation="border" size="sm" />
                    </div>
                ) : ""}
                {saving ? (
                    <div style={{fontWeight:"bold"}} className="mt-3 mb-3">
                        保存中
                        <Spinner animation="border" size="sm" />
                    </div>
                ) : ""}
                <div id="canvas-area" className="m-0 p-0" data-selectdrawflag={1} data-mosaicsize={30} data-mosaicstrength={20} data-imageeditflag={0} data-mosaicstyle={"dot"} 
                    style={{width:"auto",height:canvasAreaHeight,overflow:"auto"}}
                />
                <canvas id="original-image" style={{display:"none"}} />
                <canvas id="mosaic-image" style={{display:"none"}} />
            </div>
        </Container>
        </div>
        </div>
    )
}

export default MosaicEditPopup;
